import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useFirebase } from 'components/Firebase/index.js';
import { trackingService } from 'services/tracking/TrackingService.js';
import { getFeaturesQueryKey } from 'contexts/FeatureContext.jsx';
import useProductDataOutsideRoutes from 'hooks/useProductDataOutsideRoutes.js';

const useFeatures = () => {
  const { orgId } = useProductDataOutsideRoutes();
  const uid = useSelector(state => state.sessionState.authUser?.uid);
  const queryClient = useQueryClient();
  const firebase = useFirebase();

  const updateFeature = useMutation({
    mutationFn: async featureConfiguration => {
      const { feature, settings } = featureConfiguration || {};
      const agent = await firebase.getAgent();
      const response = await agent.patch(`/o/${encodeURIComponent(orgId)}/settings/features/${encodeURIComponent(feature)}`, settings);
      if (response?.status !== 200) return;
      return featureConfiguration;
    },
    onSuccess: (data) => {
      const queryString = new URLSearchParams({
        requestClient: 'lvsDashboard',
        ...(orgId && { orgId }),
      }).toString();

      queryClient.invalidateQueries(getFeaturesQueryKey(uid, queryString));
      trackingService.track({
        eventType: `feature-toggled:${data.feature}:${data.settings.enabled ? 'enabled' : 'disabled'}`,
      });
    },
  });

  return { updateFeature };
};

export default useFeatures;
